import { gql } from '@apollo/client';

export const DEEP_LINK_FRAGMENT = gql`
  fragment DeepLinkFragment on DeepLink {
    id
    url
    name
    campaign
    target
    params {
      gachaBoxId
      contentPackId
      redeemCode
    }
    fallbackTarget
    enabled
    endDate
    maxUses
    createdBy
    stats {
      uniqueUsers
      totalOpens
    }
    created
    updatedAt
  }
`;

export const LIVEOPS_DEEP_LINKS_QUERY = gql`
  query getLiveOpsDeepLinks {
    liveOps {
      id
      deepLinks {
        ...DeepLinkFragment
      }
    }
  }
  ${DEEP_LINK_FRAGMENT}
`;

export const CREATE_DEEP_LINK = gql`
  mutation createDeepLink(
    $name: String!
    $campaign: String
    $target: DeepLinkTarget!
    $params: DeepLinkParamsInput
    $fallbackTarget: DeepLinkTarget
    $enabled: Boolean
    $endDate: Date
    $maxUses: Int
  ) {
    createDeepLink(
      name: $name
      campaign: $campaign
      target: $target
      params: $params
      fallbackTarget: $fallbackTarget
      enabled: $enabled
      endDate: $endDate
      maxUses: $maxUses
    ) {
      ...DeepLinkFragment
    }
  }
  ${DEEP_LINK_FRAGMENT}
`;

export const UPDATE_DEEP_LINK = gql`
  mutation updateDeepLink(
    $id: ID!
    $name: String
    $campaign: String
    $target: DeepLinkTarget
    $params: DeepLinkParamsInput
    $fallbackTarget: DeepLinkTarget
    $enabled: Boolean
    $endDate: Date
    $maxUses: Int
  ) {
    updateDeepLink(
      id: $id
      name: $name
      campaign: $campaign
      target: $target
      params: $params
      fallbackTarget: $fallbackTarget
      enabled: $enabled
      endDate: $endDate
      maxUses: $maxUses
    ) {
      ...DeepLinkFragment
    }
  }
  ${DEEP_LINK_FRAGMENT}
`;

export const DELETE_DEEP_LINK = gql`
  mutation deleteDeepLink($id: ID!) {
    deleteDeepLink(id: $id)
  }
`;
